<script setup>

import { ref } from 'vue'
import { useRouter} from "vue-router/composables";

import useUsuarioStore from '../../api/v2/stores/UsuarioStore';

const usuarioStore = useUsuarioStore();
const router = useRouter();
const usuarioNome = ref(usuarioStore.usuario.nome);

const toHome = async () =>{
    router.push({ path: "/home" });
}

</script>

<template>

    <main class="v-main">

        <h1 class="v-titulo">404</h1>
        <div class="v-sub-titulo">Não encontramos a página que você tentou acessar <strong>{{ usuarioNome }}.</strong> </div>
        <div class="v-sub-titulo">Verifique o link ou clique no botão abaixo para retornar para a Home.</div>

        <v-btn class="v-to-home"
            color="primary"
            @click="toHome"
        >
            Retornar para a Home
            <v-icon> mdi-chevron-right</v-icon>
        </v-btn>

    </main>

</template>

<style scoped>

.v-main{
    display: grid;
    justify-items: center;
    gap:10px;
}

</style>